import {createApp, defineAsyncComponent} from 'vue';
import VueSweetalert2 from 'vue-sweetalert2';
import moshaToast from 'mosha-vue-toastify';
import {createStore} from "vuex";
import {ZiggyVue} from 'ziggy';
import {Ziggy} from '../ziggy';
import "./bootstrap.js";
import VueAxios from "vue-axios";
import axios from "axios";

import "./owl";
import "./wiki";
import "./general";
import "./support";
import UserStore from "./stores/user";
import ArchiveStore from "./stores/archive";
import CartStore from "./stores/cart";
import ProductStore from "./stores/product";
import CheckoutStore from "./stores/checkout";
import GeneralStore from "./stores/general";
import CompareStore from "./stores/compare";
import {deferUntilVisible} from './deferred-component';

document.addEventListener('page:load', () => {
    if (document.getElementById('main-slider')) {
        import(/* webpackChunkName: "product-gallery" */ './splide').then(module => module.initSplideSliders());
    }
});

window.$ = window.jQuery = require('jquery');
const bootstrap = require('bootstrap');

const store = createStore({});
store.registerModule('user', UserStore);
store.registerModule('archive', ArchiveStore);
store.registerModule('cart', CartStore);
store.registerModule('product', ProductStore);
store.registerModule('checkout', CheckoutStore);
store.registerModule('general', GeneralStore);
store.registerModule('compare', CompareStore);

// Keep the compare item cap in sync with the viewport (2 mobile / 4 desktop).
store.dispatch('compare/syncMax');
window.addEventListener('resize', () => store.dispatch('compare/syncMax'));

Ziggy.url = "";

const swalOptions = {
    confirmButtonColor: '#FF6634',
    cancelButtonColor: '#6c757d',
    confirmButtonText: 'بله',
    cancelButtonText: 'خیر',
    customClass: {
        popup: 'pedini-swal-popup',
        confirmButton: 'pedini-swal-confirm',
        cancelButton: 'pedini-swal-cancel',
    },
};

const siteMixin = {
    methods: {
        token(){
            return localStorage.getItem('_token');
        },
        getUser(){
            if (this.$store.state.user.type==='user') {
                return this.$store.state.user.user;
            }
            return false;
        },
        isAuthenticated(){
            return this.$store.state.user.authenticated;
        },
        isLoggedIn() {
            return this.$store.getters['user/isLoggedIn'];
        },
        checkIsLoading() {
            if (! this.isLoggedIn()) {
                window.location.href = '/login';
            }
            return this.isLoggedIn();
        },
        getUsername(){
            return this.$store.getters['user/username'];
        },
        numberFormat(number){
            return new Intl.NumberFormat().format(number);
        },
        getCsrf(){
            return document.querySelector('meta[name="csrf-token"]').getAttribute('content');
        },
        assetUrl(path){
            let base_url = document.querySelector('meta[name="public-files-url"]').getAttribute('content');
            return path.indexOf('://') === -1 ? base_url+'/'+path : path;
        },
        appUrl(path){
            let base_url = document.querySelector('meta[name="public-url"]').getAttribute('content');
            return path.indexOf('://') === -1 ? base_url+'/'+path : path;
        },
        getQueryParams(param = null){
            const urlSearchParams = new URLSearchParams(window.location.search);
            let params = {};
            for (let item of urlSearchParams.entries()){

                if(param && item[0].indexOf(param)!==0)
                    continue;

                if (item[0].indexOf('[]') >= 0){
                    let key = item[0].substr(0, item[0].length - 2);
                    if (typeof params[key] === 'undefined')
                        params[key] = [];
                    params[key].push(item[1]);
                } else {
                    params[item[0]] = item[1];
                }
            }

            if(param)
                return params[param];

            return params;
        },
        serializeObjectToQuery(obj, prefix){
            let str = [];
            for (let p in obj) {
                if (obj.hasOwnProperty(p)) {
                    let k = prefix ? prefix + "[]" : p,
                        v = obj[p];
                    str.push((v !== null && typeof v === "object") ?
                        this.serializeObjectToQuery(v, k) :
                        k+"="+v);
                }
            }
            return str.join("&");
        },
        fullText(str){
            return str. replace(/(?:\ r\n|\r|\n)/g, '<br>');
        },
        toastPosition() {
            return window.innerWidth < 768 ? 'bottom-center' : 'bottom-left';
        },
        toastOptions(type) {
            return {
                position: this.toastPosition(),
                type,
                timeout: 3000,
                showCloseButton: true,
                hideProgressBar: false,
                transition: 'slide',
                swipeClose: true,
            };
        },
        errorToast(message, error) {
            if (message === null && error) {
                message = 'خطای ناشناخته: لطفا با پشتیبانی سایت تماس بگیرید.';
                message = error.message;
                if (typeof error.response !== "undefined") {
                    if (typeof error.response.message !== "undefined") {
                        message = error.response.data.message;
                    } else if (typeof error.response.data.message !== "undefined") {
                        message = error.response.data.message;
                    }
                }
            }
            this.$moshaToast(message, this.toastOptions('danger'));
        },
        successToast(message) {
            this.$moshaToast(message, this.toastOptions('success'));
        },
        async copyTextToClipboard(text) {
            if (navigator.clipboard && window.isSecureContext) {
                await navigator.clipboard.writeText(text);
                return;
            }
            const element = document.createElement('textarea');
            element.value = text;
            element.style.position = 'fixed';
            element.style.left = '-9999px';
            document.body.appendChild(element);
            element.focus();
            element.select();
            document.execCommand('copy');
            document.body.removeChild(element);
        },
        isLoading() {
            return this.$store.state.general.loading;
        },
        startLoading() {
            this.$store.commit('general/setLoading', true);
        },
        endLoading() {
            this.$store.commit('general/setLoading', false);
        }
    },
};

function configureApp(vueApp) {
    vueApp.use(store);
    vueApp.use(VueAxios, axios);
    vueApp.use(VueSweetalert2, swalOptions);
    vueApp.use(moshaToast);
    vueApp.use(ZiggyVue, Ziggy);
    vueApp.mixin(siteMixin);
}

const contentComponents = {
    'login': defineAsyncComponent(() => import(/* webpackChunkName: "login" */ './components/login/Login.vue')),
    'profile-sidebar': defineAsyncComponent(() => import(/* webpackChunkName: "profile" */ './components/profile/ProfileSidebar.vue')),
    'profile-mobile-hub': defineAsyncComponent(() => import(/* webpackChunkName: "profile" */ './components/profile/ProfileMobileHub.vue')),
    'profile-mobile-header': defineAsyncComponent(() => import(/* webpackChunkName: "profile" */ './components/profile/ProfileMobileHeader.vue')),
    'profile-dashboard': defineAsyncComponent(() => import(/* webpackChunkName: "profile" */ './components/profile/ProfileDashboard.vue')),
    'profile-orders': defineAsyncComponent(() => import(/* webpackChunkName: "profile" */ './components/profile/ProfileOrders.vue')),
    'profile-wishlist': defineAsyncComponent(() => import(/* webpackChunkName: "profile" */ './components/profile/ProfileWishlist.vue')),
    'profile-waiting-list': defineAsyncComponent(() => import(/* webpackChunkName: "profile" */ './components/profile/ProfileWaitingList.vue')),
    'profile-addresses': defineAsyncComponent(() => import(/* webpackChunkName: "profile" */ './components/profile/ProfileAddresses.vue')),
    'profile-edit': defineAsyncComponent(() => import(/* webpackChunkName: "profile-edit" */ './components/profile/ProfileEdit.vue')),
    'filters-toggle': defineAsyncComponent(() => import(/* webpackChunkName: "archive" */ './components/archive/FiltersToggle.vue')),
    'archive-sidebar': defineAsyncComponent(() => import(/* webpackChunkName: "archive" */ './components/archive/Sidebar.vue')),
    'archive-applied-filters': defineAsyncComponent(() => import(/* webpackChunkName: "archive" */ './components/archive/AppliedFilters.vue')),
    'archive-sort': defineAsyncComponent(() => import(/* webpackChunkName: "archive" */ './components/archive/Sort.vue')),
    'archive-index': defineAsyncComponent(() => import(/* webpackChunkName: "archive" */ './components/archive/ArchiveIndex.vue')),
    'archive-pagination': defineAsyncComponent(() => import(/* webpackChunkName: "archive" */ './components/archive/Pagination.vue')),
    'add-to-cart': defineAsyncComponent(() => import(/* webpackChunkName: "product" */ './components/cart/AddToCart.vue')),
    'single-product-mobile-buy-bar': defineAsyncComponent(() => import(/* webpackChunkName: "product" */ './components/product/SingleProductMobileBuyBar.vue')),
    'single-product': defineAsyncComponent(() => import(/* webpackChunkName: "product" */ './components/product/SingleProduct.vue')),
    'comments': deferUntilVisible(() => import(/* webpackChunkName: "product-comments" */ './components/product/comments/Comments.vue')),
    'new-comment': defineAsyncComponent(() => import(/* webpackChunkName: "product" */ './components/product/comments/NewComment.vue')),
    'variations': defineAsyncComponent(() => import(/* webpackChunkName: "product" */ './components/product/Variations.vue')),
    'single-product-price': defineAsyncComponent(() => import(/* webpackChunkName: "product" */ './components/product/SingleProductPrice.vue')),
    'single-product-guarantee': defineAsyncComponent(() => import(/* webpackChunkName: "product" */ './components/product/SingleProductGuarantee.vue')),
    'product-family-variants': defineAsyncComponent(() => import(/* webpackChunkName: "product" */ './components/product/ProductFamilyVariants.vue')),
    'single-product-actions': defineAsyncComponent(() => import(/* webpackChunkName: "product" */ './components/product/SingleProductActions.vue')),
    'cart': defineAsyncComponent(() => import(/* webpackChunkName: "cart" */ './components/cart/Cart.vue')),
    'checkout': defineAsyncComponent(() => import(/* webpackChunkName: "checkout" */ './components/checkout/Checkout.vue')),
    'countdown-timer': require("./components/countdown/Countdown").default,
    'order-received': defineAsyncComponent(() => import(/* webpackChunkName: "checkout" */ './components/checkout/OrderReceived.vue')),
    'compare-toggle': defineAsyncComponent(() => import(/* webpackChunkName: "compare" */ './components/compare/CompareToggle.vue')),
    'compare-table': defineAsyncComponent(() => import(/* webpackChunkName: "compare" */ './components/compare/CompareTable.vue')),
};

function createContentApp() {
    const vueApp = createApp({});
    configureApp(vueApp);
    Object.keys(contentComponents).forEach((name) => {
        vueApp.component(name, contentComponents[name]);
    });
    return vueApp;
}

const headerApp = createApp({});
configureApp(headerApp);
headerApp.component('loading', require("./components/general/Loading").default);
headerApp.component('header-profile', require("./components/general/HeaderProfile").default);
headerApp.component('header-cart', require("./components/cart/HeaderCart").default);
headerApp.component('header-search', require("./components/general/HeaderSearch").default);

const mobileShellApp = createApp({});
configureApp(mobileShellApp);
mobileShellApp.component('mobile-menu', require("./components/general/MobileMenu").default);
mobileShellApp.component('mobile-categories-panel', require("./components/general/MobileCategoriesPanel").default);
mobileShellApp.component('mobile-shell', require("./components/general/MobileShell").default);

let contentVueInstance = null;
let headerVueInstance = null;
let mobileVueInstance = null;
let navigationController = null;
let navigationToken = 0;
let renderedPageKey = null;

const PAGE_CACHE_TTL = 45000;
const PRODUCT_PAGE_CACHE_TTL = 5000;
const PAGE_CACHE_MAX = 20;
const pageCache = new Map();
const prefetchInFlight = new Map();
const pageStyleLoads = new Map();

function loadPageStyles(urls = []) {
    return Promise.all(urls.map(url => {
        if (pageStyleLoads.has(url)) return pageStyleLoads.get(url);
        if ([...document.querySelectorAll('link[rel="stylesheet"]')].some(link => link.href === url)) return;
        const pending = new Promise((resolve, reject) => {
            const link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = url;
            link.dataset.pageStyle = '';
            link.onload = resolve;
            link.onerror = () => {
                link.remove();
                pageStyleLoads.delete(url);
                reject(new Error('Page stylesheet failed to load'));
            };
            document.head.appendChild(link);
        });
        pageStyleLoads.set(url, pending);
        return pending;
    }));
}

function refreshCsrfToken() {
    const token = document.head.querySelector('meta[name="csrf-token"]');

    if (token) {
        window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
    }
}

function dispatchPageLoad() {
    document.dispatchEvent(new Event('page:load'));
}

function mountHeaderApp() {
    if (headerVueInstance) {
        return;
    }

    if (!document.getElementById('header-app')) {
        return;
    }

    headerVueInstance = headerApp.mount('#header-app');
}

function mountContentApp() {
    const el = document.getElementById('page-content');

    if (!el) {
        return;
    }

    if (contentVueInstance) {
        contentVueInstance.unmount();
        contentVueInstance = null;
    }

    if (el.querySelector('[data-vue-islands]')) {
        // Keep server-rendered images in place: only countdowns need Vue on home.
        const islands = [...el.querySelectorAll('[data-vue-island]')].map(element => {
            const app = createContentApp();
            app.mount(element);
            return app;
        });
        contentVueInstance = {unmount: () => islands.forEach(app => app.unmount())};
    } else {
        contentVueInstance = createContentApp();
        contentVueInstance.mount('#page-content');
    }
}

function mountMobileShell() {
    if (mobileVueInstance) {
        return;
    }

    const el = document.getElementById('mobile-menu-mount');

    if (!el) {
        return;
    }

    mobileVueInstance = mobileShellApp.mount('#mobile-menu-mount');
}

async function bootstrapSession() {
    if (store.state.general.sessionReady) {
        return;
    }

    try {
        let token = localStorage.getItem('_token');

        if (token) {
            try {
                const response = await axios.get('/api/v1/check', {
                    headers: {Authorization: `Bearer ${token}`},
                });
                if (response.data.type === 'user') {
                    store.commit('user/setUser', response.data.user);
                } else {
                    store.commit('user/setUser', {});
                }
            } catch (error) {
                const guest = await axios.get('/auth-guest');
                localStorage.setItem('_token', guest.data.token);
                token = guest.data.token;
            }
        } else {
            const guest = await axios.get('/auth-guest');
            localStorage.setItem('_token', guest.data.token);
            token = guest.data.token;
        }

        if (!store.state.general.cartReady) {
            const cartResponse = await axios.get('/api/v1/cart', {
                headers: {Authorization: `Bearer ${token}`},
            });
            store.commit('cart/init', cartResponse.data);
            store.commit('general/setCartReady', true);
        }
    } catch (error) {
        // Keep browsing even if session bootstrap fails; pages can retry.
    } finally {
        store.commit('general/setSessionReady', true);
    }
}

function normalizePageUrl(url) {
    const target = new URL(url, window.location.origin);
    const publicUrl = document.querySelector('meta[name="public-url"]')?.content;
    const canonical = new URL(publicUrl || window.location.origin, window.location.origin);
    const sameSite = target.hostname.replace(/^www\./, '') === canonical.hostname.replace(/^www\./, '');
    if (sameSite && ['http:', 'https:'].includes(target.protocol) && target.port === canonical.port) {
        target.protocol = window.location.protocol;
        target.host = window.location.host;
    }
    return target;
}

function pageCacheKey(url) {
    const target = normalizePageUrl(url);
    return target.pathname + target.search;
}

function isSamePageUrl(url) {
    const targetKey = pageCacheKey(url);

    if (renderedPageKey !== null) {
        return targetKey === renderedPageKey;
    }

    return targetKey === pageCacheKey(window.location.href);
}

function isProductPageUrl(url) {
    return normalizePageUrl(url).pathname.startsWith('/product/');
}

function getCachedPage(url) {
    const key = pageCacheKey(url);
    const entry = pageCache.get(key);

    if (!entry) {
        return null;
    }

    const ttl = isProductPageUrl(url) ? PRODUCT_PAGE_CACHE_TTL : PAGE_CACHE_TTL;

    if (Date.now() - entry.at > ttl) {
        pageCache.delete(key);
        return null;
    }

    return entry;
}

function setCachedPage(url, page) {
    const key = pageCacheKey(url);

    if (pageCache.size >= PAGE_CACHE_MAX) {
        const oldestKey = pageCache.keys().next().value;
        pageCache.delete(oldestKey);
    }

    pageCache.set(key, {
        ...page,
        at: Date.now(),
    });
}

function parsePageDocument(html) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const newContent = doc.querySelector('#page-content') || doc.querySelector('#app');

    if (!newContent) {
        return null;
    }

    return {
        contentHtml: newContent.innerHTML,
        styles: [...doc.querySelectorAll('link[data-page-style]')].map(link => link.href),
        title: doc.querySelector('title')?.textContent || '',
        csrf: doc.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || null,
        canonical: doc.querySelector('link[rel="canonical"]')?.getAttribute('href') || null,
        metaDescription: doc.querySelector('meta[name="meta_description"]')?.getAttribute('content') || null,
        metaKeywords: doc.querySelector('meta[name="meta_keywords"]')?.getAttribute('content') || null,
    };
}

function syncHeadElement(selector, tagName, attributes, valueAttribute, value) {
    let element = document.head.querySelector(selector);

    if (!value) {
        element?.remove();
        return;
    }

    if (!element) {
        element = document.createElement(tagName);
        Object.entries(attributes).forEach(([name, attributeValue]) => {
            element.setAttribute(name, attributeValue);
        });
        document.head.appendChild(element);
    }

    element.setAttribute(valueAttribute, value);
}

async function fetchPage(url, signal) {
    const cached = getCachedPage(url);
    if (cached) {
        return cached;
    }

    const key = pageCacheKey(url);
    if (prefetchInFlight.has(key)) {
        return prefetchInFlight.get(key);
    }

    const request = (async () => {
        const response = await fetch(normalizePageUrl(url).href, {
            headers: {
                Accept: 'text/html',
                'X-Requested-With': 'XMLHttpRequest',
            },
            credentials: 'same-origin',
            signal,
        });

        if (!response.ok) {
            throw new Error(`Navigation failed with status ${response.status}`);
        }

        const html = await response.text();
        const page = parsePageDocument(html);

        if (!page) {
            throw new Error('Page content not found');
        }

        setCachedPage(url, page);
        return page;
    })();

    prefetchInFlight.set(key, request);

    try {
        return await request;
    } finally {
        prefetchInFlight.delete(key);
    }
}

function prefetchPage(url) {
    try {
        if (navigator.connection?.saveData || /(^|-)2g$/.test(navigator.connection?.effectiveType || '')) {
            return;
        }
        const target = normalizePageUrl(url);

        if (target.origin !== window.location.origin) {
            return;
        }

        if (target.pathname.startsWith('/admin')) {
            return;
        }

        if (isSamePageUrl(target.href) || getCachedPage(target.href)) {
            return;
        }

        fetchPage(target.href).catch(() => {});
    } catch (error) {
        // Ignore invalid prefetch URLs.
    }
}

function applyPage(page, {preserveScroll = false} = {}) {
    const pageContent = document.getElementById('page-content');
    const previousScroll = {
        x: window.scrollX,
        y: window.scrollY,
    };

    if (!pageContent) {
        return false;
    }

    if (contentVueInstance) {
        document.dispatchEvent(new Event('page:before-unload'));
        contentVueInstance.unmount();
        contentVueInstance = null;
    }

    pageContent.innerHTML = page.contentHtml;

    if (page.csrf) {
        const currentCsrfMeta = document.querySelector('meta[name="csrf-token"]');
        if (currentCsrfMeta) {
            currentCsrfMeta.setAttribute('content', page.csrf);
        }
        refreshCsrfToken();
    }

    if (page.title) {
        document.title = page.title;
    }

    syncHeadElement('link[rel="canonical"]', 'link', {rel: 'canonical'}, 'href', page.canonical);
    syncHeadElement('meta[name="meta_description"]', 'meta', {name: 'meta_description'}, 'content', page.metaDescription);
    syncHeadElement('meta[name="meta_keywords"]', 'meta', {name: 'meta_keywords'}, 'content', page.metaKeywords);

    mountContentApp();
    dispatchPageLoad();

    if (preserveScroll) {
        const restoreScroll = () => window.scrollTo(previousScroll.x, previousScroll.y);
        restoreScroll();
        window.requestAnimationFrame(restoreScroll);
    } else {
        window.scrollTo(0, 0);
    }

    return true;
}

function shouldInterceptLink(anchor) {
    if (!anchor || !anchor.href) {
        return false;
    }

    if (anchor.target && anchor.target !== '_self') {
        return false;
    }

    if (anchor.hasAttribute('download')) {
        return false;
    }

    if (anchor.dataset.spa === 'false') {
        return false;
    }

    if (anchor.getAttribute('href')?.startsWith('#')) {
        return false;
    }

    if (anchor.closest('[data-bs-toggle], [data-toggle], form')) {
        return false;
    }

    const url = normalizePageUrl(anchor.href);

    if (url.origin !== window.location.origin) {
        return false;
    }

    if (url.pathname.startsWith('/admin')) {
        return false;
    }

    return true;
}

async function navigateToPage(url, {historyMode = 'push', preserveScroll = false} = {}) {
    const target = normalizePageUrl(url);

    if (target.origin !== window.location.origin) {
        window.location.href = target.href;
        return;
    }

    if (isSamePageUrl(target.href)) {
        document.body.classList.remove('openMenu');
        store.commit('general/setCategoriesPanelOpen', false);
        return;
    }

    const token = ++navigationToken;

    if (navigationController) {
        navigationController.abort();
    }
    navigationController = new AbortController();

    store.commit('general/setLoading', true);
    document.body.classList.remove('openMenu');
    store.commit('general/setCategoriesPanelOpen', false);

    try {
        const page = await fetchPage(target.href, navigationController.signal);
        await loadPageStyles(page.styles);

        if (token !== navigationToken) {
            return;
        }

        if (historyMode === 'push') {
            history.pushState({spa: true}, '', target.href);
        } else if (historyMode === 'replace') {
            history.replaceState({spa: true}, '', target.href);
        }

        // Mark the URL before mounting so page:load listeners and Vue components
        // observe the URL that belongs to the HTML being rendered.
        renderedPageKey = pageCacheKey(target.href);

        if (!applyPage(page, {preserveScroll})) {
            window.location.href = target.href;
            return;
        }
    } catch (error) {
        if (error?.name === 'AbortError' || token !== navigationToken) {
            return;
        }
        document.dispatchEvent(new CustomEvent('page:navigation-error', {detail: {message: error?.message || 'Navigation failed'}}));
        window.location.href = target.href;
    } finally {
        if (token === navigationToken) {
            store.commit('general/setLoading', false);
        }
    }
}

window.navigateToPage = navigateToPage;
window.prefetchPage = prefetchPage;

document.addEventListener('mobile:close-categories', () => {
    store.commit('general/setCategoriesPanelOpen', false);
});

document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
        return;
    }

    const anchor = event.target.closest('a[href]');
    if (!shouldInterceptLink(anchor)) {
        return;
    }

    event.preventDefault();
    navigateToPage(anchor.href);
});

document.addEventListener('pointerdown', (event) => {
    if (event.button !== 0) {
        return;
    }

    const anchor = event.target.closest('a[href]');
    if (!shouldInterceptLink(anchor)) {
        return;
    }

    prefetchPage(anchor.href);
}, {passive: true});

async function bootstrapApp() {
    refreshCsrfToken();
    renderedPageKey = pageCacheKey(window.location.href);

    // Snapshot Blade HTML before Vue mounts (needed for clean remounts from cache).
    const initialContent = document.getElementById('page-content');
    if (initialContent) {
        setCachedPage(window.location.href, {
            contentHtml: initialContent.innerHTML,
            styles: [...document.querySelectorAll('link[data-page-style]')].map(link => link.href),
            title: document.title,
            csrf: document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || null,
            canonical: document.querySelector('link[rel="canonical"]')?.getAttribute('href') || null,
            metaDescription: document.querySelector('meta[name="meta_description"]')?.getAttribute('content') || null,
            metaKeywords: document.querySelector('meta[name="meta_keywords"]')?.getAttribute('content') || null,
        });
    }

    mountHeaderApp();
    mountMobileShell();
    mountContentApp();
    dispatchPageLoad();

    await bootstrapSession();
    await store.dispatch('compare/reconcile');

}

window.addEventListener('popstate', () => {
    const previousRenderedUrl = renderedPageKey
        ? new URL(renderedPageKey, window.location.origin)
        : null;
    const preserveScroll = isProductPageUrl(window.location.href)
        && previousRenderedUrl?.pathname.startsWith('/product/');

    navigateToPage(window.location.href, {
        historyMode: null,
        preserveScroll,
    });
});

bootstrapApp();
